module.exports = class ValidaEmail {

    static valida(_email) {

        if (!_email) {
            throw obterMsgErro("Informe seu e-mail!");
        }
    
        const email = _email.trim();
        if (email.length > 254) {
            throw obterMsgErro('O tamanho de uma conta e-mail não pode exceder o limite de 254 dígitos!');
        }
    
        if (email.indexOf(' ') !== -1) {
            throw obterMsgErro('E-MAIL possui espaços em branco!');
        }
    
        const resultado = validarArroba(email);
    
        const posArroba = resultado.posArroba;
        const usuario = email.substring(0, posArroba);
        if (usuario.length === 0) {
            throw obterMsgErro('Ausência de usuário no e-mail!');
        }
    
        validarPonto(usuario, 'usuário');
    
        const dominio = email.substring(posArroba + 1, email.length);
        if (dominio.length === 0) {
            throw obterMsgErro('Ausência de domínio no email!');
        }
    
        if (dominio.indexOf('.') === -1) {
            throw obterMsgErro('Ausência de "." no domínio!');
        }
    
        validarPonto(dominio, 'domínio');
    
        const filtro = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    
        if (!filtro.test(email)) {
            throw obterMsgErro('E-mail inválido!');
        }
    
        return { email }
    }
}

const obterMsgErro = msgErro => {
    return ({ status:400, tipo:'problema', texto:'E-mail inválido!' });
}

const validarArroba = email => {
    const iniArroba = email.indexOf('@');
    const fimArroba = email.lastIndexOf('@');
    if (iniArroba === -1 && fimArroba === -1) {
        throw obterMsgErro('E-MAIL não possui "@"!');
    }

    if (iniArroba > -1 && fimArroba > -1 && iniArroba !== fimArroba) {
        throw obterMsgErro('Existe mais de um "@" no e-mail!');
    }

    let posArroba = iniArroba;
    if (iniArroba < fimArroba) {
        posArroba = fimArroba;
    }
    if (posArroba === 0) {
        throw obterMsgErro('"@" no INÍCIO do e-mail!');
    }

    if (posArroba === (email.length - 1)) {
        throw obterMsgErro('"@" no FINAL do e-mail!');
    }

    return posArroba;
} 

const validarPonto = (campo,nomeCampo) => {
    let posPonto = campo.indexOf('.');
    if (posPonto === 0) {
        throw obterMsgErro(`Existẽncia de ponto no INÍCIO do ${nomeCampo}!`);
    }

    if (campo.lastIndexOf('.') === (campo.length - 1)) {
        throw obterMsgErro(`Existência de ponto no FINAL do ${nomeCampo}!`);
    }

    if (campo.indexOf('..') !== -1) {
        throw obterMsgErro(`Existência de dois pontos seguidos no ${nomeCampo}!`);
    }
}